import { z } from 'zod';
// =========================================================
// PIN-based authentication para usuarios de Laboratorio sin email.
// Alternativa al flujo MSAL Entra ID — el operario solo tipea un PIN
// de 4 dígitos en /lab-login.
//
// El JWT que devuelve el backend dura 30 días por default (es para
// terminales semi-permanentes). Se renueva en cada uso exitoso.
// =========================================================
const PIN_REGEX = /^\d{4}$/;
/**
 * Request del operario al hacer login. Solo el PIN — no hay username
 * (un solo PIN activo a la vez por instalación).
 */
export const LoginLabPinRequestSchema = z.object({
    pin: z.string().regex(PIN_REGEX, 'El PIN debe ser exactamente 4 dígitos numéricos'),
});
/**
 * Response del login OK. El token es nuestro JWT firmado con
 * LAB_JWT_SECRET; va en `Authorization: Bearer <token>` en llamadas
 * subsecuentes — el middleware lo detecta y lo trata como un usuario
 * con role=Laboratorio.
 */
export const LoginLabPinResponseSchema = z.object({
    token: z.string(),
    /** Etiqueta del PIN (ej: "Laboratorio"). Para mostrar en la UI. */
    etiqueta: z.string(),
    /** Epoch ms de expiración del token. La UI puede mostrar countdown. */
    expira_en: z.number().int(),
});
/**
 * Request del admin para configurar o rotar el PIN.
 */
export const ConfigurarPinLabRequestSchema = z.object({
    pin: z.string().regex(PIN_REGEX, 'El PIN debe ser exactamente 4 dígitos numéricos'),
    etiqueta: z.string().trim().min(1).max(100).optional(),
});
/**
 * Estado actual del PIN — NUNCA devuelve el PIN ni el hash, solo
 * metadata para que el admin sepa si está configurado y cuándo se usó.
 */
export const EstadoPinLabResponseSchema = z.object({
    configurado: z.boolean(),
    etiqueta: z.string().nullable(),
    creado_por_email: z.string().nullable(),
    creado_en: z.string().nullable(),
    ultimo_uso_en: z.string().nullable(),
    bloqueado_hasta: z.string().nullable(),
    intentos_fallidos: z.number().int(),
});
//# sourceMappingURL=auth-pin.js.map